import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import PageAccountSignUp from "./PageAccountSignUp";
import { Box } from "@material-ui/core";
import PageAccountSignIn from "./PageAccountSignIn";
import { SignUpSignInLink } from "./OverlayViewAccount";

const useStyles = makeStyles(() =>
    createStyles({
        signUpSignInContainer: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
        },
    })
);

interface Props {
    handleBack: () => void;
    handleNext: () => void;
    isSignedIn: boolean;
}

export default function SignUpStart({ handleBack, handleNext, isSignedIn }: Props) {
    const [isSignIn, setIsSignIn] = React.useState<boolean>(true);
    const [signInPhoneNumber, setSignInPhoneNumber] = React.useState<string>("");
    const classes = useStyles();

    useEffect(() => {
        if (isSignedIn) {
            handleNext();
        }
    }, [isSignedIn]);

    return (
        <Box className={classes.signUpSignInContainer}>
            {isSignIn ? (
                <PageAccountSignIn
                    phoneNumber={signInPhoneNumber}
                    changeToSignUpWithPhoneNumber={(phoneNumber: string) => {
                        setIsSignIn(false);
                    }}
                />
            ) : (
                <PageAccountSignUp
                    changeToSignInWithPhoneNumber={(phoneNumber: string) => {
                        setSignInPhoneNumber(phoneNumber);
                        setIsSignIn(true);
                    }}
                />
            )}
            <SignUpSignInLink
                isSignUp={!isSignIn}
                handleClick={(isSignUp) => {
                    if (isSignUp) {
                        setIsSignIn(true);
                    } else {
                        setIsSignIn(false);
                    }
                }}
            />
        </Box>
    );
}
